import { Reveal, SectionLabel, LuxBg } from "../Reveal";
import { AUDIENCE_CARDS } from "../../content";

export const Audience = () => (
  <section id="learn" className="relative py-28 md:py-36 px-6 sm:px-10 lg:px-16 xl:px-24" data-testid="audience-section">
    <LuxBg n={3} />
    <Reveal><SectionLabel num="003" text="WHO THIS IS FOR" /></Reveal>
    <Reveal delay={0.05}>
      <h2 className="serif font-black uppercase tracking-tight text-3xl md:text-5xl text-white mb-14">
        THIS TRAINING IS <span className="text-[#FE0000]">DESIGNED FOR:</span>
      </h2>
    </Reveal>
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
      {AUDIENCE_CARDS.map((c, i) => (
        <Reveal key={i} delay={i * 0.06}>
          <div
            className="group h-full rounded-lg border border-white/10 bg-white/[0.02] p-6 hover:border-[#FE0000] hover:bg-[#FE0000]/[0.08] hover:scale-[1.02] transition-[border-color,background-color,transform] duration-300"
            data-testid={`audience-card-${i}`}
          >
            <div className="text-3xl mb-4">{c.emoji}</div>
            <p className="text-base font-semibold text-white leading-snug">{c.text}</p>
          </div>
        </Reveal>
      ))}
    </div>
    <Reveal delay={0.2}>
      <button
        data-testid="audience-cta"
        data-cta
        onClick={() => document.getElementById("register")?.scrollIntoView({ behavior: "smooth" })}
        className="mt-12 bg-[#FFE100] text-[#12264A] font-bold text-sm uppercase tracking-wide px-8 py-4 rounded-md btn-slide"
      >
        ✓ RESERVE MY FREE SEAT
      </button>
    </Reveal>
  </section>
);
